import requests from "./httpService";

const ApkServices = {

  // Add new APK
  addApk: async (data) => {
    return requests.post("/appversion/add",data);  // Assuming POST to /apk/add endpoint
  },
  getApkById: async (id) => {
    return requests.get(`/appversion/${id}`);
  },
  getApkList: async () => {
    return requests.get("/appversion/"); 
  },
};

export default ApkServices;
